import { createContext, useContext, useReducer } from 'react';

const initstate = {
  id: null,
  docNo: null,
  open: false,
  onOpen: (_: string, __: string) => {},
  onClose: () => {},
};

const reducer = (state: any, action: any) => {
  switch (action.type) {
    case 'onOpen':
      return { ...state, id: action?.id, docNo: action?.docNo, open: true };
    case 'onClose':
      return { ...state, id: null, docNo: null, open: false };
    default:
      throw new Error('Unexpected action');
  }
};

const Context = createContext(initstate);

export const MainProvider = ({ children }: any) => {
  const [state, dispatch] = useReducer(reducer, initstate);
  const onOpen = (id: string, docNo: string) =>
    dispatch({ type: 'onOpen', id, docNo });
  const onClose = () => dispatch({ type: 'onClose' });
  return (
    <Context.Provider value={{ ...state, onOpen, onClose, dispatch }}>
      {children}
    </Context.Provider>
  );
};

export const useMainContext = () => useContext(Context);
